import { useState } from "react";
import {
  RequestCreateDeliveryOptionsRequest,
  AmazonCreateDeliveryOptionsPostRequest,
  AmazonApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";
import { isLwaNotConnectedError } from "../../utils/lwaError";

export const useApiCreateDeliveryOptions = () => {
  const [resultRegister, setResultRegister] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createDeliveryOptions = async (
    req: RequestCreateDeliveryOptionsRequest
  ): Promise<{ ok: boolean; notConnected: boolean }> => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: AmazonCreateDeliveryOptionsPostRequest = {
        req,
      };

      const api = new AmazonApi(config);
      const response = await api.amazonCreateDeliveryOptionsPost(request);
      setResultRegister(response);
      return { ok: response, notConnected: false };
    } catch (err: any) {
      const notConnected = isLwaNotConnectedError(err);
      const message = notConnected
        ? "LWA_NOT_CONNECTED"
        : err?.response?.data?.error ??
          "配送オプションの登録に失敗しました（不明なエラー）";
      setError(message);
      console.error(err);
      return { ok: false, notConnected };
    } finally {
      setIsLoading(false);
    }
  };

  return { createDeliveryOptions, resultRegister, error, isLoading };
};
